module.exports = __webpack_public_path__ + "assets/apoly404_black.a8fdac84.png";